import { Box, Tooltip } from '@mui/material';

interface PinterestSaveButtonProps {
  imageUrl: string;
  description: string;
  visible: boolean;
  tapped: boolean; // ✅ Add this
}

const PinterestSaveButton = ({ imageUrl, description, visible, tapped }: PinterestSaveButtonProps) => {
  const handleSave = (e: React.MouseEvent) => {
    e.stopPropagation();
    const pageUrl = window.location.href;
    const pinterestUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(pageUrl)}&media=${encodeURIComponent(imageUrl)}&description=${encodeURIComponent(description)}`;
    window.open(pinterestUrl, '_blank', 'width=750,height=550');
  };

  return (
    <Tooltip title="Pin to board" placement="left" arrow>
      <Box
        onClick={handleSave}
        sx={{
          position: 'absolute',
          top: 12,
          right: 12,        // ✅ Moved from left to right
          zIndex: 4,
          cursor: 'pointer',
          backgroundColor: '#E60023',
          borderRadius: '24px',
          height: 32,
          padding: '0 12px 0 8px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
          opacity: {
            xs: tapped ? 1 : 0,   // ✅ Mobile: tap image to reveal
            lg: visible ? 1 : 0,   // Desktop: hover to reveal
          },
          transition: 'opacity 0.2s ease-in-out',
          '&:hover': {
            opacity: 1,
            backgroundColor: '#B6001A',
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: '#FFFFFF',
            borderRadius: '50%',
            width: 20,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="#E60023">
            <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
          </svg>
        </Box>
        <span style={{
          color: '#FFFFFF',
          fontWeight: 700,
          fontSize: '13px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          lineHeight: 1,
        }}>
          Save
        </span>
      </Box>
    </Tooltip>
  );
};

export default PinterestSaveButton;